import LandingPage from "../views/Home/LandingPage";
import Nothing from "../views/404/Nothing";
import SignupForm from "../views/LoginAndSignup/SignupForm";
import LoginForm from "../views/LoginAndSignup/LoginForm";
import UserDashboard from "../views/UserDash/UserDashboard";
import AdminDashboard from "../views/AdminDash/AdminDashboard";
import Support from "../views/Support/Support";
import About from '../views/about/about'

const AppRoutes = [
  {
    path: "/",
    name: "Home",
    component: LandingPage
  },
  {
    path: "/login",
    name: "Login",
    component: LoginForm
  },
  {
    path: "/signup",
    name: "Signup",
    component: SignupForm
  },
  {
    path: "/dashboard",
    name: "UserDash",
    component: UserDashboard
  },
  {
    path: "/admindash",
    name: "AdminDash",
    component: AdminDashboard
  },
  {
    path: "/support",
    name: "Support",
    component: Support
  },
  {
    path: "/about",
    name: "about",
    component: About
  },
  {
    path: "*",
    name: "notFound",
    component: Nothing
  }
];

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/routes/AppRoutes.js